<form
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
>
  <div class="d-flex flex-direction-column gap-16">
    <app-form-control
      label="{{ 'Company name' | trans:'customers/forms/add-edit-customer-form/companyName.Label' }}"
      [hasErrors]="hasControlErrors('companyName')"
    >
      <input
        type="text"
        placeholder="{{ 'Enter company name' | trans:'customers/forms/add-edit-customer-form/companyName.Placeholder' }}"
        formControlName="companyName"
      >
    </app-form-control>

    <div class="d-flex gap-16">
      <app-form-control
        label="{{ 'First name' | trans:'customers/forms/add-edit-customer-form/firstName.Label' }}"
        [hasErrors]="hasControlErrors('firstName')"
      >
        <input
          type="text"
          placeholder="{{ 'Enter first name' | trans:'customers/forms/add-edit-customer-form/firstName.Placeholder' }}"
          formControlName="firstName"
        >
      </app-form-control>

      <app-form-control
        label="{{ 'Last name' | trans:'customers/forms/add-edit-customer-form/lastName.Label' }}"
        [hasErrors]="hasControlErrors('lastName')"
      >
        <input
          type="text"
          placeholder="{{ 'Enter last name' | trans:'customers/forms/add-edit-customer-form/lastName.Placeholder' }}"
          formControlName="lastName"
        >
      </app-form-control>
    </div>

    <app-form-control
      label="{{ 'Email' | trans:'customers/forms/add-edit-customer-form/email.Label' }}"
      [hasErrors]="hasControlErrors('email')"
    >
      <input
        type="email"
        placeholder="{{ 'Enter email' | trans:'customers/forms/add-edit-customer-form/email.Placeholder' }}"
        formControlName="email"
      >
      <ng-container errors>
        @if (getControlErrorState('email', 'email')) {
          <span>
            {{ 'Email is incorrect' | trans:'customers/forms/add-edit-customer-form/email.Incorrect' }}
          </span>
        }
      </ng-container>
    </app-form-control>

    <app-form-control
      label="{{ 'Country' | trans:'customers/forms/add-edit-customer-form/country.Label' }}"
      [hasErrors]="hasControlErrors('countryId')"
    >
      <app-select
        class="full-width"
        [options]="countries()"
        [placeholder]="'Select country' | trans:'customers/forms/add-edit-customer-form/country.Placeholder'"
        [hasResetOption]="true"
        outputType="number"
        [canUnselect]="true"
        formControlName="countryId"
      />
    </app-form-control>

    <app-form-control
      label="{{ 'Street' | trans:'customers/forms/add-edit-customer-form/street.Label' }}"
      [hasErrors]="hasControlErrors('street')"
    >
      <input
        type="text"
        placeholder="{{ 'Enter street' | trans:'customers/forms/add-edit-customer-form/street.Placeholder' }}"
        formControlName="street"
      >
    </app-form-control>

    <div class="d-flex gap-16">
      <app-form-control
        label="{{ 'City' | trans:'customers/forms/add-edit-customer-form/city.Label' }}"
        [hasErrors]="hasControlErrors('city')"
      >
        <input
          type="text"
          placeholder="{{ 'Enter city' | trans:'customers/forms/add-edit-customer-form/city.Placeholder' }}"
          formControlName="city"
        >
      </app-form-control>

      <app-form-control
        max-width="35%"
        label="{{ 'Postcode' | trans:'customers/forms/add-edit-customer-form/postalCode.Label' }}"
        [hasErrors]="hasControlErrors('postalCode')"
      >
        <input
          type="text"
          placeholder="{{ 'Enter postcode' | trans:'customers/forms/add-edit-customer-form/postalCode.Placeholder' }}"
          formControlName="postalCode"
        >
      </app-form-control>
    </div>
  </div>
</form>
